<template>
   <div id="rent-a-car-ancillaries-container">
      <ul class="details-tabs" v-if="showTabs">
         <li class="active-tab">{{ $t("rentacar_lblAncillaries") }}</li>
      </ul>
      <!-- {{ ancillaries }} -->
      <ul class="ancillaries-tabs-wrapper">
         <li v-for="(ancillary, index) in ancillariesArr" :key="index">
            <div class="ancillary-tab-wrapper" :class="ancillary.selected || ancillary.count != 0 ? 'selected' : ''">
               <div class="ancillary-icon" v-if="ancillary.type != 12 && ancillary.type != 51 && ancillary.type != 52">
                  <i class="gts-icon icon-lg" :class="'icon-rentacar-' + ancillary.icon"></i>
               </div>
               <div class="ancillary-informations">
                  <!-- <template>
                     <div class="ancillary-tooltip" v-if="ancillary.type == 6">{{ ancillary.tooltip }}</div>
                  </template> -->

                  <div class="ancillary-name-wrapper">
                     <span class="ancillary-name" v-if="ancillary.type != 12"> {{ ancillary.name }}</span>
                     <span class="ancillary-name" v-else> {{ GetLastPart(ancillary.subType) }} </span>
                     <span v-if="ancillary.type == 51 || ancillary.type == 52"> / {{ ancillary.subType }}</span>
                     <span class="rental-policies-item-badge" v-if="ancillary.paymentTimingType == 2">{{ $t("rentacar_localPayment") }}</span>
                  </div>
                  <!-- <p class="ancillary-description" v-if="ancillary.type != 12">{{ ancillary.name }}</p> -->
                  <!-- <p class="ancillary-description">{{ $options.filters.ERacPaymentTimingType(ancillary.paymentTimingType) }}</p> -->

                  <span class="ancillary-price">
                     {{ ancillary.pricePerDay | price(currency) }}
                     <template v-if="ancillary.type != 51 && ancillary.type != 52"> / {{ $t("rentacar_lblPerDay") }} </template>
                     <template v-else> / {{ $t("rentacar_lblPerBooking") }} </template>
                  </span>
                  <span class="ancillary-extra-info"
                     >{{ ancillary.dayCount }} {{ $t("rentacar_lblDay") }} x {{ ancillary.pricePerDay | price(currency) }} = {{ ancillary.totalPrice | price(currency) }}</span
                  >
               </div>
               <div class="ancillay-actions">
                  <template v-if="IsAugmentable(ancillary.type)">
                     <div class="ancillary-counter">
                        <button :class="ancillary.count > 0 ? '' : 'invisible'" @click="ancillary.count > 0 ? handlerSelectAncillary(ancillary.count, index, ancillary.type, 'dec') : ''">-</button>
                        <span> {{ ancillary.count }}</span>
                        <button
                           :class="passengerCapacity - 3 > ancillary.count ? '' : 'invisible'"
                           @click="passengerCapacity - 3 > ancillary.count ? handlerSelectAncillary(ancillary.count, index, ancillary.type, 'inc') : ''">
                           +
                        </button>
                     </div>
                  </template>

                  <template v-else>
                     <div
                        v-if="!ancillary.mandatory"
                        @click="ancillary.type != 51 ? handlerSelectAncillary(ancillary.count, index) : undefined"
                        class="ancillary-add"
                        :class="ancillary.count > 0 ? 'selected' : ''">
                        +
                     </div>
                  </template>
               </div>
            </div>
         </li>
      </ul>
   </div>
</template>

<script>
import { ancillaryConversion, ancillaryRequestModelGenerator } from "@/helper/rentacar.js";
export default {
   name: "RentACarAncillaries",
   props: {
      currency: String,
      ancillaries: Object,
      type: {
         type: String,
         default: "Search",
      },
      providerName: String,
      showTabs: {
         type: Boolean,
         default: false,
      },
      passengerCapacity: Number,
   },
   data() {
      return {
         ancillariesArr: [],
         request: {},
      };
   },

   methods: {
      GetLastPart(value) {
         return value.split("---").pop().trim();
      },

      RentACarDescriptionFMT(key) {
         const providerName = this.providerName;
         const ancillaryFmt = this.$i18n.t(`rentacar_${providerName}Description${key}`);
         return ancillaryFmt.includes("rentacar_pandoraDescription") ? "" : ancillaryFmt;
      },
      RentACarTitleFMT(key) {
         key;
         const providerName = this.providerName;
         const ancillaryFmt = this.$i18n.t(`rentacar_${providerName}Title${key}`);
         // // return ancillaryFmt.includes("rentacar_pandoraTitle") ? ancillaryFmt : ancillaryFmt;
         return ancillaryFmt;
      },

      IsAugmentable(type) {
         return type == 1 ? true : false;
      },
      handlerSelectAncillary(count, index, isAugmentable, action) {
         if (this.IsAugmentable(isAugmentable)) {
            if (action == "inc" && this.passengerCapacity - 3 > count) {
               this.ancillariesArr[index].count++;
            } else if (action == "dec" && count != 0) {
               this.ancillariesArr[index].count--;
            }
         } else {
            if (count == 0) {
               this.ancillariesArr[index].count++;
            } else {
               this.ancillariesArr[index].count--;
            }
         }
         this.handlerGenerateAncillaryRequestModel();
      },
      handlerGenerateAncillaryRequestModel() {
         const self = this;
         this.request = ancillaryRequestModelGenerator(self, this.ancillariesArr);
         this.$emit("requestModel", this.request);
      },
   },
   watch: {
      ancillaries: {
         handler: function () {
            const self = this;
            this.ancillariesArr = ancillaryConversion(self, this.ancillaries);
         },
         immediate: true,
         deep: true,
      },
   },
};
</script>

<style>
.dark-theme .rental-policies-item-badge {
   color: var(--orange-400) !important;
}
</style>

<style lang="scss" scoped>
.icon-rentacar-other,
.icon-rentacar-UNKNOWN {
   transform: scale(0.75) !important;
   opacity: 0.9;
}
.rental-policies-item-badge {
   background-color: var(--orange-100);
   color: var(--orange-500);
   border-radius: 0.5rem;
   padding: 0.25rem 0.75rem;
   font-size: var(--small);
   font-weight: 500;
   white-space: nowrap;
}
#rent-a-car-ancillaries-container {
   padding: 1rem;

   @media (max-width: 576px) {
      padding: 1rem 0;
   }

   ul.details-tabs {
      display: flex;
      width: 100%;
      justify-content: center;
      border-bottom: 4px solid var(--gray-100);
      margin-bottom: 1rem;

      li {
         font-weight: 500;
         margin: 0 0.5rem;
         font-size: 1.125rem;
         padding-bottom: 0.25rem;

         &.active-tab {
            color: var(--product-rentacar);
            font-weight: 600;
            position: relative;

            &::after {
               content: "";
               position: absolute;
               top: 100%;
               left: -5px;
               right: -5px;
               background-color: var(--product-rentacar);
               height: 4px;
               border-radius: 24rem;
            }
         }
      }
   }

   ul.ancillaries-tabs-wrapper {
      display: flex;
      flex-wrap: wrap;
      gap: 1rem;

      @media (max-width: 576px) {
         gap: 0.5rem;
      }

      li {
         flex-basis: calc(50% - 0.5rem);

         @media (max-width: 576px) {
            flex-basis: 100%;
         }

         .ancillary-tab-wrapper {
            @media (min-width: 360px) {
               padding: 0.25rem 0.5rem;
            }
            @media (min-width: 576px) {
               padding: 0.25rem 1rem;
            }
            background: var(--gray-100);
            background: #f8fafc;
            border: 2px solid var(--gray-200);
            border: 2px solid #f1f5f9;
            border-radius: 0.5rem;
            padding: 1rem;
            min-height: 72px;
            height: 100%;
            display: flex;
            justify-content: space-between;
            align-items: flex-start;

            &.selected {
               background-color: var(--teal-0);
               border: 2px solid var(--product-rentacar);
            }

            .ancillary-icon {
               border-right: 2px solid var(--gray-300);
               padding-right: 1rem;
               margin-right: 1rem;
            }

            .ancillary-informations {
               display: flex;
               flex-direction: column;
               width: 100%;
               position: relative;
               @media (min-width: 360px) {
                  // font-size: 12px;
               }
               @media (min-width: 576px) {
                  font-size: inherit;
               }
               .ancillary-name-wrapper {
                  margin-bottom: 1rem;
                  @media (max-width: 576px) {
                     display: flex;
                     flex-direction: column;
                     margin-bottom: 1rem;
                  }
               }
               span {
                  &.ancillary-name {
                     font-weight: 500;
                  }
                  &.ancillary-price {
                     font-weight: 600;
                     color: var(--orange-400);
                  }
                  &.ancillary-extra-info {
                     opacity: 0.6;
                     font-size: var(--xsmall);
                  }
               }
               .ancillary-description {
                  font-size: var(--small);
               }
               .ancillary-tooltip {
                  background: var(--accent-primary);
                  //color: var(--gray-50);
                  color: var(--gray-0);
                  position: absolute;
                  padding: 0.5rem 0.75rem;
                  border-radius: 0.125rem;
                  left: 0;
                  right: 0;
                  bottom: 100%;
                  display: none;
                  width: fit-content;
               }
               &:hover {
                  .ancillary-tooltip {
                     display: flex;
                  }
               }
            }
            .ancillary-counter {
               display: flex;
               align-items: center;
               span {
                  margin: 0 0.25rem;
                  min-width: 32px;
                  display: flex;
                  justify-content: center;
                  font-weight: 500;
                  font-size: 1.25rem;
               }
               button {
                  //background-color: var(--gray-50);
                  background-color: var(--gray-0);
                  border: 2px solid var(--gray-300);
                  font-size: var(--large);
                  display: flex;
                  align-items: center;
                  justify-content: center;
                  border-radius: 0.5rem;
                  width: 32px;
                  height: 32px;

                  &.invisible {
                     visibility: visible !important;
                     opacity: 0.5;
                     cursor: not-allowed;
                  }
               }
            }
            .ancillary-add {
               cursor: pointer;
               display: flex;
               align-items: center;
               justify-content: center;
               font-size: 1.5rem;
               width: 32px;
               height: 32px;
               //background-color: var(--gray-50);
               background-color: var(--gray-0);
               border-radius: 24rem;
               border: 2px solid var(--gray-300);

               &.selected {
                  //color: var(--gray-50);
                  color: var(--gray-0);
                  background-color: var(--product-rentacar);
                  border-color: transparent;
                  transform: rotate(45deg);
               }
            }
         }
      }
   }
}
</style>
